import React from 'react';
import BrandLogo from '../components/BrandLogo';

// Full-screen initial loading state (used while AuthContext is hydrating)
export const AppLoader = () => (
  <div className="min-h-screen bg-[#2A1810] text-[#F5EDE0] grid place-items-center">
    <div className="flex flex-col items-center gap-4">
      <div className="animate-pulse"><BrandLogo size="md" /></div>
      <div className="flex gap-1.5">
        <span className="h-2 w-2 rounded-full bg-[#F4C430] animate-bounce" />
        <span className="h-2 w-2 rounded-full bg-[#F4C430] animate-bounce" style={{ animationDelay: '120ms' }} />
        <span className="h-2 w-2 rounded-full bg-[#F4C430] animate-bounce" style={{ animationDelay: '240ms' }} />
      </div>
    </div>
  </div>
);

// Reusable content skeleton for cards / lists
export const SkeletonCard = ({ className = '' }) => (
  <div className={`rounded-2xl bg-[#3D2817] border border-[#4a3221] p-5 animate-pulse ${className}`}>
    <div className="h-3 w-24 bg-[#4a3221] rounded" />
    <div className="mt-3 h-6 w-40 bg-[#4a3221] rounded" />
    <div className="mt-6 h-2 w-full bg-[#4a3221] rounded" />
  </div>
);

// Empty state
export const EmptyState = ({ icon: Icon, title, description, action }) => (
  <div className="rounded-2xl border border-[#4a3221] bg-[#3D2817] p-8 sm:p-10 text-center">
    {Icon && (
      <div className="mx-auto h-14 w-14 rounded-2xl grid place-items-center bg-[#F4C430]/12 border border-[#F4C430]/40">
        <Icon size={22} className="text-[#F4C430]" />
      </div>
    )}
    <div className="mt-4 font-serif text-xl text-[#F5EDE0]">{title}</div>
    {description && <div className="mt-1 text-[#B8A990] text-sm">{description}</div>}
    {action && <div className="mt-5">{action}</div>}
  </div>
);
